import React, { useEffect } from 'react'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { getCurrentSelectionsAdmin, getCurrentSelectionsBySchool, getFinishedSelectionsAdmin, getFinishedSelectionsBySchool } from '../../actions/selectionsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { Link, useParams } from 'react-router-dom'
import SubMenuAdminSelection from '../../components/menus/SubMenuAdminSelection'

export default function ProcessAdmin({active = true}) {
    const { t } = useTranslation()
    const {client} = useAuth()
	const dispatch = useDispatch()

	const { id } = useParams()

    const {selections} = useSelector(state=>state.selections)

	useEffect(() => {
		if(client){
			if (id) {
				if (active) {
					dispatch(getCurrentSelectionsBySchool(id))
				} else {
					dispatch(getFinishedSelectionsBySchool(id))
				}
			} else {
				if (active) {
					dispatch(getCurrentSelectionsAdmin())
				} else {
					dispatch(getFinishedSelectionsAdmin())
				}
			}
		}
	},[dispatch, t, client, id, active])

	const columnsSelections = [
		{
			name: t('admin.dashboard.name'),
			id: 'id',
			width: "25%",
			cell: selection =>
				<div className='text-left cursor'>
					{selection?.title}
				</div>,
			selector: (selection) => selection.title,
			sortable: true,
		},{
			name: t('selection.startDateTable'),
			center: 'true',
			cell: ({ startDate }) => {
                const formattedDate = new Date(startDate).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                })
                return <div><span className='d-none'>{startDate}</span>{formattedDate}</div>
            },
			selector: (selection) => selection.startDate,
			sortable: true,
        },{
            name: t('global.status'),
            center: 'true',
			cell: selection =>
                <div>
					{
						selection.finished
						?
							<div className='pildora published'>{t('global.finished')}</div>
						:
							selection.published
							?
								<div className='pildora published'>{t('global.published')}</div>
							:
								<div className='pildora draft'>{t('global.draft')}</div>
					}
                </div>
		},{
			name: t('global.actions'),
			center: 'true',
			width: "150px",
			cell: selection =>
				<div>
					<Link to={`/admin/editprocess/${selection._id}`} className='mx-2 link'>
						<i className='fas fa-edit'></i>
					</Link>
				</div>
		}
	]

	if (!id) {
		columnsSelections.splice(1, 0, {
			name: t('school.name'),
			id: 'schoolName',
			width: "25%",
			cell: selection =>
				<div className='text-left cursor'>
					{selection?.school?.name}
				</div>,
			selector: (selection) => selection.school?.name,
			sortable: true,
		})
	}

    return (
		<>
			<Container className='cuerpo'>
				<div className='d-flex align-items-center mb-5'>
					<img src="/images/config.svg" alt="Procesos" />
					<h1 className='ms-2 m-0'>{t('menus.candidateProcesses')}</h1>
				</div>
                <Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5 selection'>
								<div className='mb-5'>
									<h3>{t('menus.activeprocesses')}</h3>
								</div>
								<SubMenuAdminSelection section={active ? "activeProcesses" : "completedProcesses"} school={id}/>
								{selections?.length > 0
									?
										<CustomDataTable
                                            columns={columnsSelections}
                                            data={selections}
                                            defaultSortField="startDate"
                                            defaultSortAsc={true}
                                        />
									:
										<div className='text-center'>{t('selection.thereisnotprocess')}</div>
								}
							</Card.Body>
						</Card>
					</Col>
				</Row>
            </Container>
        </>
    )
}